var brandStyles = {
  home: {
    sectionBackground: "light",
    socialIconEmphasis: "high",
    categoryLinkArrowColor: "primary"
  },
  homecloud: {
    sectionBackground: "light",
    socialIconEmphasis: "high",
    categoryLinkArrowColor: "primary"
  },
  ionos: {
    sectionBackground: "darker",
    socialIconEmphasis: "medium",
    categoryLinkArrowColor: "secondary"
  },
  strefa: {
    sectionBackground: "dark",
    socialIconEmphasis: "medium",
    categoryLinkArrowColor: "secondary"
  }
};
export default brandStyles;